import { selector } from 'recoil';
import { fetchMethods } from 'utils/fetch';
import { sessionKeyAtom } from 'common/state/account';

export const fetchSelector = selector({
  key: 'fetchSelector',
  get: ({ get }) => {
    get(sessionKeyAtom);

    return fetchMethods();
  },
});
